/*
  This is configurations page for offer ids that can be reused for different purposes.
  This reusable page will include the following:
  1. multiline input text field for offer ids
  2. see details button for selected offer ids and show the details in a table below for selected offer ids
  3. Submit button to save the changes
*/

import React, { useEffect, useState } from 'react'
import Form, { Textarea, BaseForm } from 'components/Form'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import { getMessage } from 'lib/translator'
import OffersListing from './OffersListing'
import PageConfig from './PageConfig'
import API from 'lib/api'
import { Dialog } from 'components/Popup'
import '../style.css'

class OfferIdsConfig extends BaseForm {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <AuthenticatedPage menu={this.props.menu}>
        <OfferIdsConfigPage _this={this} />
      </AuthenticatedPage>
    )
  }
}

function OfferIdsConfigPage({ _this }) {
  const [pageState, setPageState] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showToaster, setShowToaster] = useState(false)
  const [selectedOfferIds, setSelectedOfferIds] = useState([])
  const [errorDialog, setErrorDialog] = useState(null)
  const { SubmitButton } = _this.buttons

  useEffect(() => {
    const { pathname } = _this.props.location
    const currentPageState = PageConfig.find((page) =>
      pathname.endsWith(page.pageUrl)
    )
    setPageState(currentPageState)
  }, [])

  useEffect(() => {
    const fetchOffers = () => {
      new API({
        url: pageState.getEndpoint,
      })
        .get()
        .then((res) => {
          const offerIds = pageState.transformResponse(res)
          _this.setState({ values: { offerIds: offerIds.join('\n') } })
        })
        .catch(() => {
          setErrorDialog({
            title: 'Server Error',
            message: 'Unable to load offer IDs.',
          })
        })
    }

    if (pageState) {
      fetchOffers()
    }
  }, [pageState])

  const handleSeeDetails = (e) => {
    e.preventDefault()
    const el = document.getElementById('offer-ids-input-field')
    if (el) {
      const { value, selectionStart, selectionEnd } = el
      const selectedOffers = value.substring(selectionStart, selectionEnd)
      if (selectedOffers) {
        const selectedOfferArr = selectedOffers
          .trim()
          .split(/\r?\n/)
          .map((s) => s.trim())
        setSelectedOfferIds(selectedOfferArr)
      }
    }
  }

  const _submitHandler = (e) => {
    setLoading(true)
    e.preventDefault()
    const { values } = _this.state

    const api = new API({
      url: pageState.postEndpoint,
    })

    const offerIdsArray = values.offerIds.split('\n').map(Number)

    const payload = pageState.transformPayload(offerIdsArray)

    api
      .post(payload)
      .then(() => {
        setShowToaster(true)
      })
      .catch(() => {
        setErrorDialog({
          title: 'Server Error',
          message: 'Unable to save offer IDs.',
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (!pageState) {
    return null
  }

  return (
    <div className="offer-ids-config-page">
      <div className="flex-around">
        <h1 className="title heading">
          <strong>{pageState.name}</strong>
        </h1>
      </div>
      {showToaster && (
        <div className="success-offer-ids-config" id="succcess-dialog">
          {getMessage('offer.offers.config.success.toast.text')}
          <strong
            data-testid="ok-strng-btn"
            onClick={() => setShowToaster(false)}
            className="strong-btn"
          >
            {getMessage('rewardPage.dialogs.disable.okText')}
          </strong>
        </div>
      )}
      <Form onSubmit={(e) => _submitHandler(e)}>
        <Textarea
          className="text-area-offer-ids-config"
          type="text"
          name="offer-ids-input-field"
          key="offer-ids-input-field"
          testid="offer-ids-input-field"
          label={pageState.name}
          placeholder={getMessage(
            'offer.campaigns.form.offerSchedules.offerIds.placeholder'
          )}
          {..._this.generateStateMappers({
            stateKeys: ['offerIds'],
            loseEmphasisOnFill: true,
          })}
        />
        <span className="help-text">
          Select the offer IDs and click See Details for more info
        </span>
        <div className="buttons-wrapper">
          <SubmitButton disabled={loading}>
            {getMessage('offer.submit')}
          </SubmitButton>

          <button
            className="button secondary see-details-btn"
            onClick={handleSeeDetails}
          >
            See Details
          </button>
        </div>
      </Form>

      {errorDialog && (
        <Dialog
          show
          title={errorDialog.title}
          information={errorDialog.message}
          close={() => setErrorDialog(null)}
          closeText="OK"
        />
      )}

      {selectedOfferIds?.length > 0 && (
        <>
          <div className="divider"></div>
          <OffersListing
            history={_this.props.history}
            selectedOfferIds={selectedOfferIds}
          />
        </>
      )}
    </div>
  )
}
export default OfferIdsConfig
